import { Paper, Tabs, styled } from '@mui/material'; // Temporary demo

export var GridItem = styled(Paper)(function () {
  return {
    backgroundColor: 'transparent',
    boxShadow: 'none'
  };
});
export var BGWhiteTabs = styled(Tabs)(function () {
  return {
    '& .Mui-selected': {
      backgroundColor: 'white',
      borderTopRightRadius: '8px',
      borderTopLeftRadius: '8px'
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent'
    }
  };
});